<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke-linecap="round"
    stroke="currentColor"
    stroke-width="2"
    stroke-linejoin="round"
  >
    <path d="M6 13 10 17 18 8" />
  </svg>
</template>
